import { t } from "@/i18n-js/instance";
import { EMAIL_REGEX } from "@circle-react/components/OnboardingPage/helpers/constants";
import { CheckoutForm } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/CheckoutForm";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import { CheckoutFormField } from "../../CheckoutFormField";
import { useEmailVerificationInitialState } from "./hooks/useEmailVerificationInitialState";

const LOCALE_ROOT =
  "paywall_checkout.form.email_verification_states.initial_state";

interface EmailVerificationInitialStateProps {
  isValidating?: boolean;
  onAuthenticationLinkClick?: () => void;
  shouldShowAuthenticationLink?: boolean;
}

export const EmailVerificationInitialState = ({
  isValidating = false,
  shouldShowAuthenticationLink = false,
  onAuthenticationLinkClick,
}: EmailVerificationInitialStateProps) => {
  const { handleBlur, handleAuthenticationClick } =
    useEmailVerificationInitialState({
      onAuthenticationLinkClick,
    });

  return (
    <div className="flex flex-col gap-2 p-6">
      <CheckoutForm.Item name="email">
        <div className="relative">
          <CheckoutFormField
            type="text"
            name="email"
            onBlur={handleBlur}
            options={{
              required: true,
              pattern: EMAIL_REGEX,
            }}
          />
          {isValidating && (
            <div className="absolute right-0 top-1/2 -translate-y-1/2">
              <Loader />
            </div>
          )}
        </div>
      </CheckoutForm.Item>
      {shouldShowAuthenticationLink && (
        <div className="flex items-center gap-2 pt-2">
          <Icon
            className="text-v2-warning"
            type="info"
            size={20}
            useWithFillCurrentColor
          />
          <Typography.LabelXs weight="normal" color="text-tertiary">
            <Button
              type="button"
              disabled={isValidating}
              variant="link"
              onClick={handleAuthenticationClick}
              className="text-tertiary hover:text-primary !h-auto !p-0 underline"
            >
              <Typography.LabelXs weight="medium" color="inherit">
                {t([LOCALE_ROOT, "authenticate_account"])}
              </Typography.LabelXs>
            </Button>
            {` ${t([LOCALE_ROOT, "before_completing_checkout"])}`}
          </Typography.LabelXs>
        </div>
      )}
    </div>
  );
};
